export default __webpack_public_path__ + "static/media/205.4da9dfc6.jpg";